export default {"src":"/_next/static/media/NEXO.faeed489.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};